<template>
  <ContactSalesPopup
    @close="toggleContactSales"
    :contactSalesActive="contactSalesActive"
    class="overflow-y-hidden"
  >
  </ContactSalesPopup>
  <!-- footer start -->
  <div class="footer_stunner bg-cover bg-bottom bg-no-repeat xl:bg-auto">
    <!-- kindness & support -->
    <section class="min-[1200px]:h-[275px] -mt-[138px] flex lg:mx-0">
      <div
        class="min-[1200px]:flex mx-auto mt-[185px] mb-[35px] w-[1200px] justify-between pl-[25px] text-[#fff] lg:pl-0"
      >
        <div class="mb-[20px] flex lg:px-[15px]">
          <img
            :src="$filters.media_path('images/white-lifesaver-icon.svg')"
            alt=""
            style="height: 45px"
          />

          <h3 class="ml-[15px] place-self-center text-[16px]">
            <b>Free training</b> & 24-hour support
          </h3>
        </div>
        <div class="mb-[20px] flex lg:px-[15px]">
          <img
            :src="$filters.media_path('images/security-white-badge-icon.svg')"
            alt=""
            style="height: 45px"
          />

          <h3 class="ml-[15px] place-self-center text-[16px]">
            Serious about <b>security & privacy</b>
          </h3>
        </div>
        <div class="mb-[20px] flex lg:px-[15px]">
          <img
            :src="$filters.media_path('images/white-gauge-icon.svg')"
            alt=""
            style="height: 45px"
          />

          <h3
            class="min-[280px]:text-xs min-[450px]:text-[16px] ml-[15px] place-self-center"
          >
            <b>Highest levels of uptime</b> the last 12 months
          </h3>
        </div>
      </div>
    </section>
    <!-- footer links -->
    <nav
      class="mx-auto flex max-w-[1200px] border-y-[1px] border-[rgba(255,255,255,0.25)] px-[25px] pb-[60px] lg:content-evenly xl:px-0"
    >
      <div
        class="min-[1200px]:flex m-w-[1200px] mx-auto ml-3 mt-[60px] flex-grow lg:content-evenly xl:ml-0"
      >
        <div class="flex-grow xl:w-[240px]">
          <ul class="space-y-5">
            <li class="text-xs font-bold text-[#fff]">PLATFORMA</li>
            <li>
              <a
                href="/download"
                class="5xl:text-lg text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Download</a
              >
            </li>
            <li>
              <Link
                href="/careers"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Careers</Link
              >
            </li>
            <li>
              <Link
                href="/about"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >About Us</Link
              >
            </li>
            <!-- <li> -->
            <!--   <a -->
            <!--     href="" -->
            <!--     class="text-sm text-[#fff] duration-300 ease-in-out hover:underline" -->
            <!--     >Product Roadmap</a -->
            <!--   > -->
            <!-- </li> -->
            <li>
              <Link
                href="/status"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Status</Link
              >
            </li>
          </ul>
        </div>

        <div class="flex-grow xl:w-[240px]">
          <ul class="min-[1200px]:mt-0 mt-5 space-y-5">
            <li class="5xl:text-base text-xs font-bold text-[#fff]">
              RESOURCES
            </li>
            <li>
              <a
                href="https://help.platformarea.com"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Help Docs</a
              >
            </li>
            <li>
              <a
                @click="toggleContactSales"
                type="button"
                class="cursor-pointer text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Contact Us
              </a>
            </li>
            <!-- <li> -->
            <!--   <a -->
            <!--     href="/live-streaming-webinars" -->
            <!--     class="text-sm text-[#fff] duration-300 ease-in-out hover:underline" -->
            <!--     >Webinars</a -->
            <!--   > -->
            <!-- </li> -->
            <li>
              <a
                href="/web-app/api"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >API</a
              >
            </li>
          </ul>
        </div>

        <div class="flex-grow xl:w-[240px]">
          <ul class="min-[1200px]:mt-0 mt-5 space-y-5">
            <li class="5xl:text-base text-xs font-bold text-[#fff]">
              FEATURES
            </li>
            <li>
              <a
                href="/online-courses"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Online Courses</a
              >
            </li>
            <li>
              <Link
                href="/coaching"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Coaching</Link
              >
            </li>
            <li>
              <Link
                href="/group-newsfeed"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Newsfeed</Link
              >
            </li>
            <li>
              <Link
                href="/live-streaming-webinars"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Live Streaming</Link
              >
            </li>
            <li>
              <Link
                href="/video-channels"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Video Channels</Link
              >
            </li>
            <li>
              <Link
                href="/quizzes"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Quizzes</Link
              >
            </li>
            <li>
              <Link
                href="/make-money-online"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Monetization</Link
              >
            </li>
            <li>
              <Link
                href="/custom-domains"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Custom Domains</Link
              >
            </li>
            <li>
              <Link
                href="/integrations"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Integrations</Link
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="ml-3 mt-[60px] flex-grow lg:flex lg:content-evenly xl:ml-0">
        <div class="flex-grow xl:w-[240px]">
          <ul class="space-y-5">
            <li class="5xl:text-base text-xs font-bold text-[#fff]">
              SOLUTIONS
            </li>
            <li>
              <Link
                href="/course-creators"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Course Creators</Link
              >
            </li>
            <li>
              <Link
                href="/coaches"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Coaches</Link
              >
            </li>
            <li>
              <Link
                href="/influencers"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Influencers</Link
              >
            </li>
            <li>
              <Link
                href="/consultants"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Consultants</Link
              >
            </li>
            <li>
              <Link
                href="/video-creators"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Video Creators</Link
              >
            </li>
            <li>
              <Link
                href="/podcasters"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Podcasters</Link
              >
            </li>
            <li>
              <Link
                href="/membership-sites"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Memberships Sites</Link
              >
            </li>
            <li>
              <Link
                href="/online-communities"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Communities</Link
              >
            </li>
            <li>
              <Link
                href="/programs-and-courses"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Programs Courses</Link
              >
            </li>
            <li>
              <Link
                href="/leads-and-sales"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >Lead Nurture</Link
              >
            </li>
          </ul>
        </div>
        <div class="flex-grow xl:w-[240px]">
          <ul class="mt-5 space-y-5 lg:mt-0">
            <li class="xs:mt-4 5xl:text-base text-xs font-bold text-[#fff]">
              COMPARE
            </li>
            <li>
              <Link
                href="/kajabi-vs-platforma"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >vs Kajabi</Link
              >
            </li>
            <li>
              <Link
                href="/teachable-vs-platforma"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >vs Teachable</Link
              >
            </li>
            <li>
              <Link
                href="/memberspro-vs-platforma"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >vs MembersPro</Link
              >
            </li>
            <li>
              <Link
                href="/mighty-networks-vs-platforma"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >vs Mighty Networks</Link
              >
            </li>
            <li>
              <Link
                href="/patreon-vs-platforma"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >vs Patreon</Link
              >
            </li>
            <li>
              <Link
                href="/discord-vs-platforma"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >vs Discord</Link
              >
            </li>
            <li>
              <Link
                href="/clickfunnels-vs-platforma"
                class="text-sm text-[#fff] duration-300 ease-in-out hover:underline"
                >vs Clickfunnels</Link
              >
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- footer bottom -->
    <footer
      class="flex h-[124px] flex-col align-bottom sm:justify-between xl:w-full"
    >
      <div class="w-full pt-[25px] md:ml-[25px] xl:mx-auto xl:w-[1200px]">
        <Link href="/">
          <img
            class="mx-auto flex h-[30px] md:ml-0"
            :src="$filters.media_path('images/platforma-logo-white.svg')"
            alt="Platforma awesome logo"
          />
        </Link>
        <h4 class="mt-4 mb-5 text-center text-xs text-[#fff] md:text-left">
          ©
          {{ currentYear }}
          Platform Application, Inc. |
          <Link href="/privacy"> Your Privacy</Link> |
          <Link href="/terms"> Terms</Link>
        </h4>
      </div>
    </footer>
  </div>
</template>

<script>
import CtaBlock from '../Components/CtaBlockFooterComponent.vue';

export default {
  layout: CtaBlock
};
</script>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import ContactSalesPopup from '../Components/ContactSalesPopup.vue';

const contactSalesActive = ref(false);
const currentYear = new Date().getFullYear();

const toggleContactSales = () => {
  contactSalesActive.value = !contactSalesActive.value;
};
</script>

<style scoped>
.cta-block {
  background-image: url(../media/images/two-dots.svg);
  background-size: auto;
}

.footer_stunner {
  background-image: url(../media/images/platforma-stunner-footer-bg-gradient.svg);
}
</style>
